<template>
  <div>
    <crud-table
      create-route="leagues.create"
      :columns="fields"
      vuex-prefix="leagues"
      create-role="Developer"
      :fetch-address="fetchRoute"
    >
      <template #cell(logoAdd)="data">
        <img style="height: 40px" :src="data.item.logoAdd" />
      </template>
      <template #cell(appId)="data">
        {{ data.item.application.name }}
      </template>
      <template #cell(startDate)="data">
        {{ data.item.start_date }}
      </template>
      <template #cell(endDate)="data">
        {{ data.item.end_date }}
      </template>
      <template #cell(startTime)="data">
        {{ data.item.start_time }}
      </template>
      <template #cell(endTime)="data">
        {{ data.item.end_time }}
      </template>
      <template #cell(isActive)="data">
        <span
          :class="{
            'text-success': data.item.isActive == 1,
            'text-danger': data.item.isActive == 0,
          }"
        >
          {{ data.item.isActive ? 'فعال' : 'غیرفعال' }}
        </span>
      </template>
      <template #cell(isTaeid)="data">
        <span
          :class="{
            'text-success': data.item.isTaeid == 1,
            'text-danger': data.item.isTaeid == 0 || data.item.isTaeid == null,
          }"
        >
          {{ data.item.isTaeid ? 'تایید شده' : 'تایید نشده' }}
        </span>
      </template>
      <template #cell(playerJoinCount)="data">
        {{ data.item.playerJoinCount }} نفر
      </template>
      <template #cell(limitPlayerCount)="data">
        {{
          data.item.limitPlayerCount == '-1'
            ? 'بدون محدودیت'
            : data.item.limitPlayerCount + ' نفر'
        }}
      </template>
      <template #cell(actions)="data">
        <table-action-buttons
          fa-title="برنامه"
          route="leagues"
          role="Developer"
          permission="league"
          :record-id="data.item.id"
          :delete-title="data.item.name"
          @deleted="data.itemDeleted(data.itemDeleted(data.item))"
        >
          <template slot="extra-buttons">
            <router-link
              title="لیدر بورد"
              v-b-tooltip.hover
              class="ml-4"
              :to="{
                name: 'leagues.leader-board',
                params: { id: data.item.id },
              }"
            >
              <i class="ri ri-user-line font-size-18 text-warning"></i>
            </router-link>
            <router-link
              title="جوایز"
              v-b-tooltip.hover
              class="ml-4"
              :to="{
                name: 'leagues.rewards',
                params: { leagueId: data.item.id },
              }"
            >
              <i class="ri ri-gift-2-line font-size-18 text-primary"></i>
            </router-link>
            <router-link
              title="فیلدهای اطلاعات"
              v-b-tooltip.hover
              class="ml-4"
              :to="{
                name: 'leagues.data-fields',
                params: { leagueId: data.item.id },
              }"
            >
              <i class="ri ri-database-2-line font-size-18 text-success"></i>
            </router-link>
          </template>
        </table-action-buttons>
      </template>
    </crud-table>
  </div>
</template>

<script>
export default {
  props: {
    applicationId: {
      type: [Number, String, null],
      required: false,
    },
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          sortable: true,
          label: 'نام لیگ',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'appId',
          sortable: true,
          label: 'اپلیکیشن مربوطه',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          filter: {
            name: 'application.name',
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'logoAdd',
          sortable: false,
          label: 'آیکن',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '80px' },
        },
        {
          key: 'isActive',
          sortable: false,
          label: 'فعال بودن',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '80px' },
          filter: {
            component: 'SwitchFilter',
            operator: '$eq',
            value: 0,
          },
        },
        {
          key: 'isTaeid',
          sortable: false,
          label: 'وضعیت تایید',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '80px' },
          filter: {
            component: 'SwitchFilter',
            operator: '$eq',
            value: 0,
          },
        },
        {
          key: 'playerJoinCount',
          sortable: true,
          label: 'تعداد شرکت کنندگان',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          show: false,
          filter: {
            component: 'NumberFilter',
            operator: '$gte',
            value: '',
          },
        },
        {
          key: 'limitPlayerCount',
          sortable: true,
          label: 'حداکثر شرکت کنندگان',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          show: false,
          filter: {
            component: 'NumberFilter',
            operator: '$gte',
            value: '',
          },
        },
        {
          key: 'startDate',
          sortable: true,
          label: 'تاریخ شروع',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          show: false,
          filter: {
            component: 'DateFilter',
            operator: '$between',
            value: [],
            format: 'jYYYYjMMjDD',
          },
        },
        {
          key: 'startTime',
          sortable: true,
          label: 'ساعت شروع',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          show: false,
          filter: {
            component: 'TimeFilter',
            operator: '$gte',
            value: '',
            format: 'HHmm',
          },
        },
        {
          key: 'endDate',
          sortable: true,
          label: 'تاریخ پایان',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          show: false,
          filter: {
            component: 'DateFilter',
            operator: '$between',
            value: [],
            format: 'jYYYYjMMjDD',
          },
        },
        {
          key: 'endTime',
          sortable: true,
          label: 'ساعت پایان',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          show: false,
          filter: {
            component: 'TimeFilter',
            operator: '$lte',
            value: '',
            format: 'HHmm',
          },
        },
      ]
    },

    fetchRoute() {
      return this.applicationId != undefined
        ? `applications/${this.applicationId}/leagues`
        : 'leagues'
    },
  },
  data() {
    return {
      application: null,
    }
  },
}
</script>
